export default "__VITE_ASSET__Dx89l2sC__"